import { UserProfile } from '../types/auth.types';
import authService from './auth.service';

const API_BASE_URL = '/api/v1';

class ProfileService {
  async getProfile(): Promise<UserProfile> {
    const res = await authService.fetchWithAuth(`${API_BASE_URL}/profile`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      throw new Error(err?.detail || 'Failed to fetch profile');
    }
    return res.json();
  }
}

export const profileService = new ProfileService();
